import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppBar } from "../../components/appBar/appBarContext";
import CustomisedCardLine from "../../components/card/cardLine";
import ChequeCardImage from "../../components/chequeCard/chequeCardImage";
import { setHeaderTitle } from "../../redux/headerTitle/headerTitleSlice";
import { IChequeInfo } from "./ICheque";
import EventIcon from '@mui/icons-material/Event';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TextCard from "../../components/card/TextCard";
import InfoIcon from '@mui/icons-material/Info';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


export default function ChequeInfo({ cheque, index }: IChequeInfo) {


    var x: { [key: number]: string } = {
        1: "اول",
        2: "دوم",
        3: "سوم",
        4: "چهارم",
        5: "پنجم",
        6: "ششم",
        7: "هفتم",
        8: "هشتم",
        9: "نهم",
        10: "دهم",
        11: "یازدهم",
        12: "دوازدهم",
        13: "سیزدهم",
        14: "چهاردهم",
        15: "پانزدهم",
        16: "شانزدهم",
        17: "هفدهم",
        18: "هجدهم",
        19: "نوزدهم",
        20: "بیستم",
        21: "بیست و یکم",
        22: "بیست و دوم",
        23: "بیست و سوم",
        24: "بیست و چهارم",
        25: "بیست و پنجم",
        26: "بیست و ششم",
        27: "بیست و هفتم",
        28: "بیست و هشتم",
        29: "بیست و نهم",
        30: "سی ام",
        31: "سی و یکم",
        32: "سی و دوم",
        33: "سی و سوم",
        34: "سی و چهارم",
        35: "سی و پنجم",
        36: "سی و ششم",
        37: "سی و هفتم",
        38: "سی و هشتم",
        39: "سی و نهم",
        40: "چهلم",
        41: "چهل و یکم",
        42: "چهل و دوم",
        43: "چهل و سوم",
        44: "چهل و چهارم",
        45: "چهل و پنجم",
        46: "چهل و ششم",
        47: "چهل و هفتم",
        48: "چهل و هشتم",
    };


    const { setHeader } = useAppBar();
    const dispatch = useDispatch();

    const chequeInfo = [
        //TODO
        {
            title: <><EventIcon sx={{ marginLeft: "5px" }} />تاریخ سررسید</>,
            value: cheque.dueDatePersian,
        },
        {
            title: <><AttachMoneyIcon sx={{ marginLeft: "5px" }} />مبلغ به عدد (ريال)</>,
            value: cheque.amount.toLocaleString()
        },
        {
            value: <TextCard title={"مشخصات چک"} description={[
                {
                    firstColumnText: 'شناسه ملی مقصد',
                    secondColumnText: cheque.expectedIdCode
                },
                {
                    firstColumnText: 'در وجه',
                    secondColumnText: cheque.expectedHolder
                },
                {
                    firstColumnText: 'شماره صیادی',
                    secondColumnText: cheque.sayadNumber
                },
                {
                    firstColumnText: 'سری و سریال چک',
                    secondColumnText: cheque.seriesNo + " / " + cheque.serialNo
                },
            ]} />
        },




        // {
        //  title: <><InfoIcon sx={{ marginLeft: "5px" }} />وضعیت</>,     
        //     value: cheque.
        // },
        // {
        //     title: <><CalendarMonthIcon sx={{ marginLeft: "5px" }} />تاریخ آخرین وضعیت</>,
        //     value: data.feeAmount
        // },
    ]


    useEffect(() => {

        var chequeIndex = 'چک قسط ' + x[index + 1]
        dispatch(
            setHeaderTitle({
                color: "var(--header-color)",
                header: chequeIndex,
                parentRoute: 'installmentCheque',
            })
        );

    }, [])


    return (
        <>
            <span style={{ paddingBottom: "12px", fontSize: "14px", display: "inline-block", paddingRight: "10px" }} className="primaryColorLight-900">اطلاعات چک</span>
            <CustomisedCardLine
                itemList={chequeInfo}
            />
            <span style={{ paddingBottom: "12px", paddingTop: "30px", fontSize: "14px", display: "inline-block", paddingRight: "10px" }} className="primaryColorLight-900">تصاویر چک</span>
            <ChequeCardImage fileUrl={(cheque.frontImage?.fileUrl) ? cheque.frontImage.fileUrl : ""} title="روی چک"></ChequeCardImage>
            <ChequeCardImage fileUrl={(cheque.rearImage?.fileUrl) ? cheque.rearImage.fileUrl : ""} title="پشت چک" ></ChequeCardImage>


        </>
    )
}